export default __webpack_public_path__ + "static/media/xcomb-tequila.b7660ec1.png";